module.exports = __webpack_public_path__ + "static/img/acsColor.9d1ed3b8.png";